import { render } from "./FileUploadDragDrop.vue?vue&type=template&id=3b0e1b05&scoped=true"
import script from "./FileUploadDragDrop.vue?vue&type=script&lang=js"
export * from "./FileUploadDragDrop.vue?vue&type=script&lang=js"

import "./FileUploadDragDrop.vue?vue&type=style&index=0&id=3b0e1b05&scoped=true&lang=css"

import exportComponent from "/Users/daniel/Documents/CETECREA/cetecrea/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0e1b05"]])

export default __exports__